'use client';

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import Stars1 from './assets/star-group-1.png';
import Stars2 from './assets/star-group-2.png';
import Stars3 from './assets/star-group-3.png';

export function Starfield() {
  const [positions, setPositions] = useState([0, 0, 0]);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setPositions(prev => prev.map((_, i) => y * ((i + 1) * 0.05)));
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={1}
      sx={{
        overflow: 'hidden',
        backgroundColor: '#000',
      }}
    >
      {/* Background ellipse */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url("/discover/coaching/ellipse1990.svg")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover', // scale to fill the whole screen
        }}
      />

      {/* Single layer per star group */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `url(${Stars1.src})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat',
          backgroundPosition: `center calc(-${positions[0]}px)`,
          mixBlendMode: 'screen',
          // backgroundColor: '#113',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `url(${Stars2.src})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat',
          backgroundPosition: `center calc(-${positions[1]}px)`,
          mixBlendMode: 'screen',
          // backgroundColor: '#224',
          // filter: 'blur(0.5px)',
          opacity: 0.8,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `url(${Stars3.src})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat',
          backgroundPosition: `center calc(-${positions[2]}px)`,
          mixBlendMode: 'screen',
          // backgroundColor: '#335',
          // filter: 'blur(1px)',
          opacity: 0.5,
        }}
      />
    </Box>
  );
}
